// 商品自身活动标签
<template>
    <div :class="['good-tag-box', themeType, { 'is-meet': isMeet }]"
         v-show="show">
        <div class="content">
            <BuyCarItemTag :text="tagName"
                           :bgColor="getGoodsTagBg" />
            <span class="van-ellipsis content-tips">{{ getTagContent }}</span>
        </div>
    </div>
</template>
<script>
import BuyCarItemTag from './BuyCarItemTag.vue';
export default {
    name: '',
    mixins: [],
    components: { BuyCarItemTag },
    // 数据部分
    props: {
        themeType: {
            type: String,
            default: 'full-minus' // 默认满减
        },
        hitGiftActiveInfo: {
            type: Object,
            default: () => { }
        },
        goodsInfo: {
            type: Object,
            default: () => { }
        }
    },
    data () {
        return {
            show: true,
            value: true,
            isMeet: false,
            multipeNum: 1 // 每满， 每买 满足活动的次数
        };
    },
    computed: {
        tagName () {
            const { hitGiftActiveInfo } = this;
            return hitGiftActiveInfo.Tags[0].TagName || '';
        },
        getTagContent () {
            return this.getActiveContent();
        },
        getGoodsTagBg () {
            const { isMeet } = this;
            if (!isMeet) {
                return 'transparent';
            }
            return 'linear-gradient(328deg, #FF6831 0%, #F3180E 100%)';
        }
    },
    watch: {
        goodsInfo: {
            handler (v) {
                this.setMeet();
            },
            immediate: true,
            deep: true
        },
        hitGiftActiveInfo: {
            handler (v) {

            },
            immediate: true,
            deep: true
        },
        show: {
            handler (v) {
                this.$emit('checkActiveTagNoticeShow', v)
            },
            immediate: true,
            deep: true
        }
    },
    // 生命周期
    created () { },
    mounted () { },
    unmounted () { },
    // 方法
    methods: {
        // 判断当前信息是否满足当前所属活动规则
        setMeet () {
            const {
                goodsInfo: { Count, PriceLimit, checked }
            } = this;
            if (!checked) {
                this.isMeet = false;
                return;
            }
            const { ConditionType, Configs } = this.hitGiftActiveInfo;
            const { Condition } = Configs[0] || [];
            if (ConditionType === 3 && Count >= Condition) {
                // 判断是否满足  指定数量 送礼
                this.isMeet = true;
            } else if (ConditionType === 4) {
                // 每买数量
                // 判断是否满足  每买指定数量 送礼
                if (Count >= Condition) {
                    // 购买数是指定数的倍数
                    this.isMeet = true;
                    const multipeNum = this.getMultipe(Count, Condition);
                    this.multipeNum = multipeNum;
                } else {
                    this.isMeet = false;
                }
            } else if (ConditionType === 1 && Count * PriceLimit >= Condition) {
                // 满钱
                // 判断是否满足 指定金额  送礼
                this.isMeet = true;
            } else if (ConditionType === 2) {
                // 每满
                // 判断是否满足  每满指定金额 送礼
                if (Count * PriceLimit >= Condition) {
                    // 购买数是指定数的倍数
                    this.isMeet = true;
                    const multipeNum = this.getMultipe(Count * PriceLimit, Condition);
                    this.multipeNum = multipeNum;
                } else {
                    this.isMeet = false;
                }
            } else {
                this.isMeet = false;
            }
            // console.log('当前商品数量---->', Count)
            // console.log('当前商品原价---->', PriceLimit)
            // this.isMeet = false
        },
        // 满足活动商品选中
        checkedActiveTagChange (val) {
            console.log(val);
        },
        // 每买、每满是判断当前数值书否是活动数值的倍数（金额或者数量）
        isMultipleNum (num, MultipleNum) {
            console.log('----->每买求值倍数取余');
            console.log(num % MultipleNum);
            return num % MultipleNum === 0;
        },
        // 获取倍数
        getMultipe (num, MultipleNum) {
            console.log('---->满足的倍数为：');
            console.log(num / MultipleNum);
            return parseInt(num / MultipleNum) || 1;
        },
        // 根据活动规则和当前是否满足活动规则，返回文字提示
        getActiveContent () {
            const {
                goodsInfo: { Count, PriceLimit }
            } = this;
            // multipeNum 是每买，每满时，当前满足活动规则的倍数
            const { isMeet, multipeNum } = this;
            const { ConditionType, Configs } = this.hitGiftActiveInfo;
            let giftTypeMsg = '';

            // 满赠活动赠品只有一条配置，取第一个
            // 同一个商品下，多个活动（满赠）导致的多个赠品，全送。
            // 每个赠品的多个阶梯的，取满足条件的最高阶梯
            let userMeetConfig = null
            let lastCondition = 0
            Configs.forEach((tt) => {
                if (tt.ConditionValueType == 3) {
                    // 按照数量
                    if (
                        Count * 1 >= tt.Condition &&
                        tt.Condition >= lastCondition
                    ) {
                        lastCondition = tt.Condition
                        userMeetConfig = tt
                    }
                } else {
                    // 按照价格
                    if (
                        Count * PriceLimit >= tt.Condition &&
                        tt.Condition >= lastCondition
                    ) {
                        lastCondition = tt.Condition
                        userMeetConfig = tt
                    }
                }
            })
            const { ActivityConfigPresent, ConditionValueType, Condition, Discount, DiscountType } = userMeetConfig || [];
            if (!isMeet) {
                // 未满足时
                giftTypeMsg += ConditionType == 1 ? '满' : ConditionType == 2 ? '每满' : ConditionType == 3 ? '买' : '每买';
                giftTypeMsg += Condition;
                giftTypeMsg += ConditionValueType == 1 ? '元' : '盒';
                // 条件值类型   折扣 = 1, 金额 = 2,
                if (DiscountType) {
                    giftTypeMsg += DiscountType == 1 ? '减' : '总价打';
                }
                if (Discount) {
                    giftTypeMsg += Discount;
                }
                // 动作结束语
                if (DiscountType) {
                    giftTypeMsg += giftTypeMsg + DiscountType == 2 ? '折' : '';
                }
                // 赠品信息
                giftTypeMsg += this.getGiftContent(ActivityConfigPresent);
            } else {
                // 如果是每买、每满  需乘以满足活动的次数
                giftTypeMsg += this.getGiftContent(ActivityConfigPresent)
                // 如果是每买、每满  提示继续赠送的信息
                if (ConditionType === 2 || ConditionType === 4) {
                    giftTypeMsg += `，再买${Condition}${ConditionValueType == 1 ? '元' : '盒'}多送`;
                    giftTypeMsg += this.getGiftContent(ActivityConfigPresent, 'buyMore')
                }
            }
            if (giftTypeMsg.indexOf('undefined') > 0) {
                this.show = false
            } else {
                this.show = true
            }
            return giftTypeMsg;
        },
        getGiftContent (giftArr, buyMore) {
            const { multipeNum, isMeet } = this;
            if (!giftArr || !giftArr.length) {

                return "";
            }
            this.$forceUpdate()
            let giftShowContent = `${isMeet ? (buyMore ? "" : '已赠送') : "赠送"}`;
            for (let index = 0; index < giftArr.length; index++) {
                const item = giftArr[index];
                const calcNum = buyMore ? 1 : (item.Limit && multipeNum >= item.Limit ? item.Limit : multipeNum)
                const giftUnit = item.Unit ? item.Unit : (item.Type === 3 ? "张" : "盒")
                giftShowContent += `${
                    isMeet ? item.Amount * calcNum : item.Amount
                    }${giftUnit}${item.Name ?? ""}${
                    index < giftArr.length - 1 ? "、" : ""
                    }`;
            }
            return giftShowContent;
        },
    }
};
</script>
<style lang="less" scoped>
.good-tag-box {
    height: 24px;
    line-height: 1;
    padding-left: 6px;
    box-sizing: border-box;
    line-height: 24px;
    display: block;
    font-size: 0;
    padding-right: 20px;
    border-radius: 4px;
    max-width: max-content;
    margin-bottom: 8px;
    &:last-child {
        margin-bottom: 0;
    }
    .content {
        text-align: left;
        display: flex;
        align-items: center;
        font-size: 12px;
    }
    &.full-minus {
        color: #ffffff;
        background: linear-gradient(328deg, #ff6831 0%, #f3180e 100%);
        background-size: 100%;
        &.is-meet {
            background: #ffeeec;
            background-size: 100%;
            color: #111a34;
        }
    }
}
</style>
